import React, { useMemo, useState } from 'react';
// @ts-ignore
import styles from '../PatientProfileV2.module.scss';
import FirstUpper from '../../FirstUpper';
import LinkButton from '../../Button/LinkButton';
import { Theme } from '../../../Enums/Theme.enum';
import PatientProfilePersonActingOnBehalfOfAPatientModal from '../../../Modules/Patient/Components/PersonActingOnBehalfOfAPatient/PersonActingOnBehalfOfAPatientModal';
import Loading from '../../Loading';
import useTranslation from '../../../Hooks/useTranslation';
import usePatientMeta from '../Hooks/usePatientMeta';
import { Meta } from '../../../graphql/graphql';

interface Props {
	patientId: string;
	patientMeta: Meta[];
}

const PatientProfilePersonActingOnBehalfOfAPatient: React.FC<Props> = ({
	patientId,
	patientMeta,
}) => {
	const { t } = useTranslation();
	const [isEditOpen, setIsEditOpen] = useState(false);
	const {
		personActingOnBehalfOfAPatient,
		hasPersonActingOnBehalfOfAPatient,
		getPersonActingOnBehalfOfAPatient,
		reFetchMeta,
		metaIsLoading,
	} = usePatientMeta(patientId, patientMeta);

	const handleAfterChange = async () => {
		setIsEditOpen(false);
		await reFetchMeta();
	};

	if (metaIsLoading) {
		return <Loading />;
	}

	return (
		<>
			<div className={styles.item}>
				<div className={styles.name}>
					<FirstUpper>
						{t('component.patientProfilePersonActingOnBehalfOfAPatient.title')}
					</FirstUpper>
					:
				</div>
				{hasPersonActingOnBehalfOfAPatient ? (
					<>
						<div className={styles.code}>
							{getPersonActingOnBehalfOfAPatient()}
						</div>
						<LinkButton
							title='base.change'
							theme={Theme.BLUE}
							onClick={() => setIsEditOpen(true)}
							firstUpper
						/>
					</>
				) : (
					<LinkButton
						title='base.setup'
						theme={Theme.BLUE}
						onClick={() => setIsEditOpen(true)}
						firstUpper
					/>
				)}
			</div>
			<PatientProfilePersonActingOnBehalfOfAPatientModal
				patientId={patientId}
				isOpen={isEditOpen}
				onClose={() => setIsEditOpen(false)}
				defaultValues={personActingOnBehalfOfAPatient}
				onSuccess={handleAfterChange}
			/>
		</>
	);
};

export default PatientProfilePersonActingOnBehalfOfAPatient;
